import { isDocustream } from "helpers/core";
import i18n from "i18n";
import { t } from "i18next";
import { normalizeLocale } from "pages/media/utils";

export const i18nProvider = {
  translate: (key: string, params) => {
    if (!params) {
      params = {};
    }

    // custom edge cases with reserved variables prefixed with "_"
    const currentBrand = isDocustream() ? "Docustream" : "Libertify";
    // LEAVING THIS IN CASE WE WANT TO BRING IT BACK LATER
    // const experienceLabel = isDocustream() ? "Docustream" : "Ai Ready Media";

    const finalParams = {
      _brand: currentBrand,
      _experience: "Experience",
      // give priority to the custom params so they can override the default ones
      ...params,
    };

    if (import.meta.env.NODE_ENV === "development") {
      return t(key, finalParams as Record<string, unknown>);
    }
    // default translation value in case no custom defaultValue
    // to not display the key as fallback
    if (
      typeof finalParams === "object" &&
      finalParams.defaultValue === undefined
    ) {
      finalParams.defaultValue = "";
    }
    // not necessary currently
    // if (params.defaultValue === null) {
    //   return 'null'
    // }
    return t(key, finalParams as Record<string, unknown>);
  },
  changeLocale: (lang: string) => i18n.changeLanguage(lang),
  getLocale: () => normalizeLocale(i18n.language),
};
